import React from 'react';

import { Client } from 'src/constants';
import { ContextBarTabs } from 'src/features/context-bar/ContextBarTabs';
import { useContextBar } from 'src/hooks/useContextBar';
import { useAppSelector } from 'src/hooks/useStore';
import {
  selectAllCompaniesMap,
  selectClientsMap,
} from 'src/store/clients/types';

const activeClientFilter = (c: Client) =>
  c.entityStatus !== 'DELETED' && c.entityStatus !== 'ARCHIVED';

export const ContextBar = () => {
  const clientsMap = useAppSelector(selectClientsMap);
  const companiesMap = useAppSelector(selectAllCompaniesMap);
  const allClients = useAppSelector((state) => state.clients.clients);

  const { target } = useContextBar();
  const { entityType, id: entityId } = target ?? {};

  const client =
    entityType === 'client' && entityId ? clientsMap.get(entityId) : undefined;
  const company =
    entityType === 'company' && entityId
      ? companiesMap.get(entityId)
      : undefined;

  const companyClients = React.useMemo(() => {
    if (entityType !== 'company') return undefined;
    return allClients.filter((c: Client) => {
      return (
        (entityId === c.fields.companyId ||
          (entityId && c.fields.companyIds?.includes(entityId))) &&
        activeClientFilter(c)
      );
    });
  }, [entityType, entityId, allClients]);

  if (!entityType || !entityId) return null;
  if (entityType === 'client' && !client) return null;
  if (entityType === 'company' && !company) return null;

  return (
    <section className="box-border h-full z-50">
      <ContextBarTabs
        entityType={entityType}
        entityId={entityId}
        clients={companyClients}
      />
    </section>
  );
};
